import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMathEquals: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconMathEquals"><Path fillRule="evenodd" clipRule="evenodd" d="M4 9.25C4 8.83579 4.33579 8.5 4.75 8.5H19.25C19.6642 8.5 20 8.83579 20 9.25C20 9.66421 19.6642 10 19.25 10H4.75C4.33579 10 4 9.66421 4 9.25ZM4 14.75C4 14.3358 4.33579 14 4.75 14H19.25C19.6642 14 20 14.3358 20 14.75C20 15.1642 19.6642 15.5 19.25 15.5H4.75C4.33579 15.5 4 15.1642 4 14.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMathEquals;
